import React from 'react';
import { SparklesIcon } from 'lucide-react';
import ChatInterface from '../components/ChatInterface';
const Home: React.FC = () => {
  return <div data-id="element-329">
      <div className="bg-white rounded-lg shadow-sm p-8 mb-8" data-id="element-330">
        <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-331">
          Post-Clinical Cancer Network Guidelines for Non-Small Cell Lung Cancer
          (NSCLC)
        </h1>
        <p className="text-xl text-gray-600 mb-6" data-id="element-332">v.1.0.0 October 2025</p>
        <p className="text-lg text-gray-700 mb-4" data-id="element-333">
          The PCCN is a platform comprising:
        </p>
        <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-334">
          <li data-id="element-335">
            <strong data-id="element-336">PCCN Guidelines:</strong> AI-powered, expert-reviewed
            guidelines (vetted by the authoritative PCCN advisory board) for
            advanced cancer patients who exhausted the standard of care
          </li>
          <li data-id="element-337">
            <strong data-id="element-338">PCCN Navigators:</strong> Hundreds of Trained and
            PCCN-certified oncology nurses who assist patients in navigating the
            PCCN guidelines
          </li>
          <li data-id="element-339">
            <strong data-id="element-340">PCCN Treatments:</strong> A range of treatments available
            through the network
          </li>
        </ul>
      </div>
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-lg shadow-sm p-8 mb-8 border-2 border-blue-200" data-id="element-341">
        <div className="flex items-center gap-3 mb-4" data-id="element-342">
          <div className="bg-gradient-to-br from-blue-600 to-purple-600 p-3 rounded-lg" data-id="element-343">
            <SparklesIcon className="h-8 w-8 text-white" data-id="element-344" />
          </div>
          <div data-id="element-345">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-346">
              AI-Powered Personalized Analysis
            </h2>
            <p className="text-lg text-gray-600" data-id="element-347">
              Get a customized treatment roadmap based on your patient case
            </p>
          </div>
        </div>
        <p className="text-gray-700 mb-6" data-id="element-348">
          Our AI assistant analyzes patient cases and generates comprehensive,
          personalized summaries of all relevant PCCN guidelines - including
          NCCN options, clinical trials, off-guideline drugs, whole health
          approaches, and the latest innovations. Simply paste your patient case
          details to receive an actionable treatment roadmap.
        </p>
        <ChatInterface data-id="element-349" />
      </div>
    </div>;
};
export default Home;